'use client';

import { Fragment } from 'react';
import styles from './CommandoCulture.module.scss';
import { useAOS } from '@/src/lib/hooks/useAOS';

interface CommandoCultureProps {
  eyebrow?: string;
  title?: string;
  highlightedTitle?: string;
  description?: string;
  backgroundImage?: string;
  tilt?: 'left' | 'right';
  id?: string;
}

const DEFAULT_BG =
  'https://ik.imagekit.io/lindahestia/articles/team_paris_meeting_under_100kb.webp?updatedAt=1782748073705';

const DEFAULT_DESCRIPTION = `Nous intervenons comme partenaire de delivery auprès des ESN et des grandes organisations qui souhaitent sécuriser un projet exigeant, compléter une équipe ou confier un périmètre à une taskforce senior clairement responsable.`;

const renderTitle = (text: string) => {
  const parts = text.split('*');
  return parts.map((part, i) =>
    i % 2 === 1 ? <em key={i}>{part}</em> : <Fragment key={i}>{part}</Fragment>
  );
};

const renderParagraphs = (text: string) =>
  text.split('\n\n').map((paragraph, i) => (
    <p key={i} className={styles.paragraph}>
      {paragraph}
    </p>
  ));

export function CommandoCulture({
  eyebrow = 'NOTRE MODÈLE',
  title = 'Un partenaire de delivery',
  highlightedTitle = '*pas une équipe à manager*',
  description = DEFAULT_DESCRIPTION,
  backgroundImage = DEFAULT_BG,
  tilt = 'right',
  id,
}: CommandoCultureProps) {
  useAOS();

  const tiltClass = tilt === 'left' ? styles.tiltLeft : styles.tiltRight;

  return (
    <section
      id={id}
      className={`${styles.root} ${tiltClass}`}
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <div className={styles.bgOverlay} aria-hidden="true" />
      <div className={styles.inner}>
        <div className={styles.header} data-aos="fade-up" data-aos-duration="700">
          {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
          <h2 className={styles.title}>
            {renderTitle(title)}{' '}
            <span className={styles.highlight}>{renderTitle(highlightedTitle)}</span>
          </h2>
        </div>

        {description && (
          <div
            className={styles.body}
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-delay="100"
          >
            {renderParagraphs(description)}
          </div>
        )}
      </div>
    </section>
  );
}
